import { render, staticRenderFns } from "./CareerAIConsentDialog.vue?vue&type=template&id=5483677c&scoped=true"
import script from "./CareerAIConsentDialog.vue?vue&type=script&lang=js"
export * from "./CareerAIConsentDialog.vue?vue&type=script&lang=js"
import style0 from "./CareerAIConsentDialog.vue?vue&type=style&index=0&id=5483677c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5483677c",
  null
  
)

export default component.exports